import { useMemo } from 'react';

import { TeamMembers } from '@vyce/core/src/views/teamMembers';
import { TeamMembersModuleProvider } from '@vyce/core/src/contexts';
import { useTeamMembersData } from '@vyce/core/src/modules/teamMembersModule/hooks/useTeamMembersData';
import { getAllTeamMembersRequest } from '@vyce/core/src/api/teams';
import { ChatUser } from '@vyce/core/src/types';

import { useTypedSelector } from '../../hooks';

export const TeamMembersModule = () => {
  const { selectedCompany, selectedCompanyAppData } = useTypedSelector(state => state.helper);
  const { user } = useTypedSelector(state => state);
  const chatCreator: ChatUser = {
    uid: user.uuid,
    name: `${user.first_name} ${user.last_name}`,
    email: user.email,
    phone: user.phone,
    avatarUrl: user.photo?.url,
  };
  const hookData = useTeamMembersData({
    companyId: selectedCompany?.uuid,
    teams: selectedCompanyAppData?.teams || [],
    getAllTeamMembersRequest,
    chatCreator,
  });

  const contextValues = useMemo(() => ({ ...hookData, withProfileButton: true }), [hookData]);

  return (
    <TeamMembersModuleProvider value={contextValues}>
      <TeamMembers />
    </TeamMembersModuleProvider>
  );
};
